import { useCallback, useState } from 'react';

import { enqueueSnackbarError } from 'lib/helpers';
import { InAppPopulatedSaleResult, InAppQRSale, listInAppQRSales } from 'lib/models/order';

function useInAppQrSales() {
	const [username, setUsername] = useState<string | null>(null);
	const [loading, setLoading] = useState<boolean>(false);

	const [data, setData] = useState<InAppPopulatedSaleResult>({
		total: 0,
		elements: [],
	} as InAppPopulatedSaleResult);

	const refetch = useCallback(
		async (data: InAppQRSale) => {
			setLoading(true);
			const response = await listInAppQRSales({ ...data, username });
			setData(response);
			if (response.user?.username) {
				setUsername(response.user?.username);
			}
			setLoading(false);
			if (response.error) {
				setUsername(null);
				enqueueSnackbarError(response.error);
			}
		},
		[username]
	);

	const resetUsername = useCallback(() => {
		setUsername(null);
	}, []);

	return { loading, data, refetch, setLoading, resetUsername };
}

export default useInAppQrSales;
